var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex justify-between" }, [
      _c(
        "label",
        {
          staticStyle: { "font-weight": "normal" },
          attrs: { for: `budget-input-${_vm.pkg.package_options[0].id}` },
        },
        [_vm._v("\n      Set your budget\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "money" }, [
        _c("span", { staticClass: "money__symbol" }, [
          _vm._v(_vm._s(_vm.moneySymbol)),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.pkg.package_options[0].budget,
              expression: "pkg.package_options[0].budget",
            },
          ],
          staticClass: "money__input",
          attrs: {
            id: `budget-input-${_vm.pkg.package_options[0].id}`,
            type: "number",
            min: "0",
            step: "10",
          },
          domProps: { value: _vm.pkg.package_options[0].budget },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.pkg.package_options[0],
                "budget",
                $event.target.value
              )
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    !_vm.validation.budget.required
      ? _c("div", { staticClass: "help-block" }, [
          _vm._v("You must set a budget"),
        ])
      : _vm.budgetHint
      ? _c("div", [_vm._v(_vm._s(_vm.budgetHint))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }